import { ShareFormationUrlContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const ShareFormationUrlProvider = createStaticContextProvider(
  ShareFormationUrlContext,
  lazyValue(() =>
    import("./share-formation-url").then((module) => module.shareFormationUrl),
  ),
);
